<table [showLoadingSpinner]="loading" class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th (click)="sortBy_click('customers.last_name')">
        Name {{ this._sortColumn === 'customers.last_name' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">Email</th>
      <th class="no-sort">Phone</th>
      <th [hidden]="!this.options.allowEditing || !this.canEditCustomers"></th>
    </tr>
  </thead>

  @for (
    item of this.dataSource.data;
    track item.id;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.id != undefined) {
      <tr
        id="trsummary_{{ item.id }}"
        [ngClass]="{ even: even, odd: odd }"
        class="cpo-selectable-table__row"
      >
        <td>
          {{ item.firstName }} {{ item.lastName }}
        </td>
        <td>
          {{ item.emailAddress }}
        </td>
        <td>
          {{ item.phone }}
        </td>

        <td style="text-align:right; white-space: nowrap;" [hidden]="!this.options.allowEditing || !this.canEditCustomers">
          <app-icon [style]="'cursor: pointer; margin-right: 30px;'" title="Edit Customer" [color]="'var(--color-action-icon)'"
            (click)="_selectRow_click(item.id)" type="Edit" [hidden]="!this.canEditCustomers"></app-icon>
          <app-icon [style]="'cursor: pointer;'" title="Delete customer" [color]="'var(--color-action-icon-delete)'"
          (click)="deleteRow_click(item.id)" type="Trash" [hidden]="!this.canEditCustomers"></app-icon>
        </td>
      </tr>
    }
    @if (this.options.selectAction == 'expand') {
      <tr
        id="trdetails_{{ item.id }}"
        class="rowDetails noHover"
        style="display: none"
      >
        <td colspan="5">
          <div>
            <b>Customer Details</b>
          </div>
        </td>
      </tr>
    }
  }
</table>
